import React, { useState, useEffect } from 'react';

const Loader = ({ onLoadComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Animation de chargement pendant 2.5 secondes
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Attendre la fin de l'animation de sortie avant de notifier
      setTimeout(() => {
        if (onLoadComplete) onLoadComplete();
      }, 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Cercles d'animation en arrière-plan */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl animate-pulse delay-300"></div>
      </div>

      {/* Contenu principal */}
      <div className="relative flex flex-col items-center gap-8">
        {/* Logo avec animation */}
        <div className="relative">
          {/* Cercle tournant autour du logo */}
          <div className="absolute inset-0 -m-8">
            <div className="w-full h-full border-4 border-transparent border-t-yellow-500 border-r-yellow-400 rounded-full animate-spin"></div>
          </div>
          
          {/* Logo SOGI avec animation de zoom et fade */}
          <div className="relative animate-fade-zoom">
            <img
              src="https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/a4svjjfw_400dpiLogoCropped.png"
              alt="SOGI Logo"
              className="h-32 w-auto filter drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Texte avec animation */}
        <div className="text-center space-y-2 animate-slide-up">
          <h2 className="text-2xl md:text-3xl font-bold text-white">
            SOGI
          </h2>
          <p className="text-yellow-400 text-sm md:text-base font-semibold tracking-wider">
            Excellence en Construction
          </p>
        </div>

        {/* Barre de progression */}
        <div className="w-64 h-1 bg-gray-700 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-yellow-500 to-yellow-400 animate-progress"></div>
        </div>
      </div>

      {/* Animations CSS personnalisées */}
      <style jsx>{`
        @keyframes fade-zoom {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.05);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slide-up {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }

        .animate-fade-zoom {
          animation: fade-zoom 1s ease-out;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out 0.3s both;
        }

        .animate-progress {
          animation: progress 2.5s ease-in-out;
        }

        .delay-300 {
          animation-delay: 300ms;
        }
      `}</style>
    </div>
  );
};

export default Loader;
